import HttpClient from '../utility/http-client';

export default {
    cartList(page: number, rowPerPage: number, q: any) {
        const url = `/api/cart/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    cartByIds(ids: string) {
        const url = `/api/cart/?ids=${ids}`;
        return HttpClient.instance().get(url);
    },

    cartEdit(dataRequest: any, cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    cartRemoveItem(itemId: number) {
        const url = `/api/cart_detail/${itemId}`;
        return HttpClient.instance().delete(url);
    },

    cartRemoveProducts(itemIds: number[]) {
        const url = `/api/cart_detail/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemoveCarts(itemIds: number[]) {
        const url = `/api/cart/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemove(cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().delete(url);
    },

    cartConfirm(itemIds: number[], otherOptions: any) {
        const url = `/api/confirm_order/`;
        return HttpClient.instance().post(url, { 'Products': itemIds, 'OtherOptions': otherOptions });
    },

    bulk_action(itemIds: number[], otherOptions: any, isDeposit: boolean, chinaStoreID, receivePlaceID) {
        const url = `/api/bulk_action/`;
        return HttpClient.instance().post(url, { 'ActionType': 'cart-deposit', 'IsDeposit': isDeposit, 'Products': itemIds,  'OtherOptions': otherOptions, 'ChinaStoreID': chinaStoreID, 'ReceivePlaceID': receivePlaceID});
    },

    finishCart(dataRequest: any) {
        const url = `/api/main_order/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    cartAddItem(item: any) {
        const url = `/api/cart/`;
        return HttpClient.instance().put(url, item);
    },

    searchProducts(siteName: string, searchTerm: string, isMobile: boolean) {
        const url = `/api/taobao_search/?term=${searchTerm}&site=${siteName}&mobile=${isMobile ? 1 : 0}`;
        return HttpClient.instance().get(url);
    },

    listProducts() {
        const url = `/api/taobao_products/`;
        return HttpClient.instance().get(url);
    },

    detailProduct(siteURL: string, translate: boolean = false) {
        const url = `/api/taobao_product_detail/?url=${encodeURIComponent(siteURL)}&translate=${translate ? 1 : 0}`;
        return HttpClient.instance().get(url);
    },

    searchProductsByKeyword(
        keyword: string,
        platform: string = 'taobao',
        page: number = 1,
        pageSize: number = 24,
        priceOrder: '' | 'asc' | 'desc' = '',
        salesOrder: '' | 'asc' | 'desc' = ''
    ) {
        let url = `/api/elim_search/?keyword=${encodeURIComponent(keyword)}&platform=${platform}&page=${page}&pageSize=${pageSize}`;
        if (priceOrder) {
            url += `&price_order=${priceOrder}`;
        }
        if (salesOrder) {
            url += `&sales_order=${salesOrder}`;
        }
        return HttpClient.instance().get(url);
    },

    searchProductsByImage(
        imageFile: File,
        platform: string = 'taobao',
        page: number = 1,
        perPage: number = 30,
        priceOrder: string = '',
        salesOrder: string = '',
    ) {
        const formData = new FormData();
        formData.append('image', imageFile);
        formData.append('platform', platform);
        formData.append('page', String(page));
        formData.append('per_page', String(perPage));
        if (priceOrder) { formData.append('price_order', priceOrder); }
        if (salesOrder) { formData.append('sales_order', salesOrder); }
        return HttpClient.instance().post('/api/image_search/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    searchProductsByImageUrl(
        imgUrl: string,
        platform: string = 'taobao',
        page: number = 1,
        perPage: number = 30,
        priceOrder: string = '',
        salesOrder: string = '',
    ) {
        const formData = new FormData();
        formData.append('img_url', imgUrl);
        formData.append('platform', platform);
        formData.append('page', String(page));
        formData.append('per_page', String(perPage));
        if (priceOrder) { formData.append('price_order', priceOrder); }
        if (salesOrder) { formData.append('sales_order', salesOrder); }
        return HttpClient.instance().post('/api/image_search/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};

